import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TableRow } from '../../../components/table/table.interface';

@Component({
  selector: 'app-samples-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [{ provide: TabComponent, useExisting: SamplesTabComponent }],
  templateUrl: './samples-tab.component.html',
  styleUrl: './samples-tab.component.scss',
})
export class SamplesTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Samples');

  constructor(private router: Router) {
    super();
  }

  public async main(): Promise<void> {}

  onRowClick = (row: TableRow) => {
    const catalogueId = row.value['catalogueId'];
    const productName = row.value['Product'];

    if (typeof catalogueId === 'string' && catalogueId.trim()) {
      this.router.navigate(['/samples', catalogueId, productName]);
    }
  };
}
